import Card from "./Card";

const Grid = (props) => {
        const {openMenu, setContentSlideMenu, ConfigVar} = props;

    return <div className="grid grid-cols-3 gap-4">
        {Object.keys(ConfigVar.apps).map((item, i) => {
            const app = ConfigVar.apps[item];
            const cardProps = {
                title: app.title,
                text: app.description,
                link: app.link,
                colorBg: ConfigVar.color,
                colorText: ConfigVar.colorText,
                image: app.image,
            };
            if (typeof app.link !== 'string') {
                cardProps.openMenu = openMenu;
                cardProps.contentMenu = () => setContentSlideMenu(app.link);
            }
            return <Card key={i} {...cardProps} />;
        })}</div>
};

export default Grid;